import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { movedTarget } from '@shh/shared';
import { RouterProvider } from 'react-router';
import { router } from './app/router';
import { MovedPage } from './pages/start/MovedPage';
import './styles.css';
// sets <html lang> to the device language before anything renders (1.19)
import './lib/locale';
// catches the browser's install offer before any page is loaded (W9)
import './lib/install';
import { captureInvite } from './lib/invite';

// a test family invitation (1.17) is kept before anything else looks at the address
captureInvite();

// On an old address only the moving notice renders – Firebase never starts there.
const moved = movedTarget(window.location, import.meta.env.VITE_OLD_HOST);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {moved ? <MovedPage target={moved} /> : <RouterProvider router={router} />}
  </StrictMode>,
);
